import { createFileRoute } from '@tanstack/react-router'

import { BranchesPage } from '@/pages/branches-page'

export const Route = createFileRoute('/_dashboard-layout/branches')({
    component: BranchesPage,
})
